var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", [
    _c(
      "tr",
      _vm._l(_vm.cols, function (col, i) {
        return _c("th", { key: i }, [_vm._v(" " + _vm._s(col) + " ")])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }